export const getEnvironment = () => {
  const host = window.location.hostname.toLowerCase();

  if (host.includes("int") || host === "localhost") return "int";
  if (host.includes("pre")) return "pre";
  return "pro";
};
